$(document).ready(function () {

    var date = $('.countdown').data("date");
    // Set the date to countdown to (replace with your desired date)
    var countDownDate = new Date(date).getTime();

    // Update the countdown every 1 second
    var x = setInterval(function () {
        // Get the current date and time
        var now = new Date().getTime();

        // Calculate the remaining time in milliseconds
        var distance = countDownDate - now;

        // Calculate days, hours, minutes, and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the countdown in the specified HTML element
        $("#day").html(days);
        $("#hour").html(hours);
        $("#minuite").html(minutes);
        $("#second").html(seconds);

        // If the countdown is over, display a message (you can modify this part)
        if (distance < 0) {
            clearInterval(x);
            $("#countdown").html("EXPIRED");
        }
    }, 1000);


    // featured-collection start
    $(".featured-collection__items").slick({
        dots: false,
        slidesToShow: 4,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $('.featured-collection__btn_left').click(function () {
        $(this).parent().parent().parent().parent().find('.slick-slider').slick('slickPrev');
    });
    $('.featured-collection__btn_right').click(function () {
        $(this).parent().parent().parent().parent().find('.slick-slider').slick('slickNext');
    });


    // insta
    $(".insta__items").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
        ],
    });

    // header mobile menu


    const $toggleBtn = $(".header__ham-icn");
    const $navMenu = $(".header__menu-drawer");
    const $menuClose = $(".header__mobile-close");

    $toggleBtn.on("click", function () {
        const isActive = $navMenu.hasClass("active");

        if (!isActive) {
            $navMenu.css("transform", "translate(0)");
            $navMenu.addClass("active");
        } else {
            $navMenu.css("transform", "translate(100%)");
            $navMenu.removeClass("active");
        }
    });

    $menuClose.on("click", function () {
        $navMenu.css("transform", "translate(100%)");
        $navMenu.removeClass("active");
    });



    // header mobile menu accordion


    $('.mobile-accor-icn').off("click").on("click", function () {
        $(this).toggleClass('active').children('.header__dropdown').slideToggle();
    });



    function initializeAccordion() {
        $('.header__dropdown').show();
        var windowWidth = $(window).width();
        var $footerMenuTitle = $('.footer__menu-title');
        var $footerMenuContent = $('.footer__menu-content');

        if (windowWidth < 768) {
            $footerMenuTitle.off("click").on("click", function () {
                $(this).toggleClass('active').next('.footer__menu-content').slideToggle();
            });
        } else {
            // Remove the click event on desktop
            $footerMenuTitle.off("click");
            // Ensure that the accordion is closed on desktop
            $footerMenuTitle.removeClass('active');
            $footerMenuContent.slideDown(); // Use slideUp instead of slidedown
        }
    }

    $(document).ready(function () {
        initializeAccordion();
    });

    $(window).on("resize", function () {
        initializeAccordion();
    });





});



$(document).ready(function() {
    $(window).resize()
  var flexItems = $(".featured-product__items_first .featured-product__item");
  if (flexItems.length >=4) {
    flexItems.parent().css("justify-content", "flex-start");
  }
});




$( "#loacation" ).on( "change", function() {
    var form  = $(this).closest('form');
   var code =  $(this).find(':selected').attr('data-value')
    form.find('input[name="country_code"]').val(code);
    form.submit();

    // console.log("", $(this));

  } );

